import React from "react";
import { Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  PageContainer,
  ContentBox,
  Title,
  LastUpdated,
  SectionTitle,
  Paragraph,
} from "./TermsPage.styled";

const TermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Container maxWidth="md">
        <ContentBox>
          <Title>{t("terms.title")}</Title>
          <LastUpdated>{t("terms.lastUpdated")}</LastUpdated>

          <Paragraph>{t("terms.intro")}</Paragraph>

          <SectionTitle>{t("terms.sections.platformOverview.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.platformOverview.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.eligibility.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.eligibility.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.betaDisclaimer.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.betaDisclaimer.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.dataOwnership.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.dataOwnership.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.intellectualProperty.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.intellectualProperty.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.paymentTerms.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.paymentTerms.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.limitationOfLiability.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.limitationOfLiability.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.hipaaCompliance.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.hipaaCompliance.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.termination.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.termination.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.governingLaw.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.governingLaw.content")}</Paragraph>

          <SectionTitle>{t("terms.sections.contact.title")}</SectionTitle>
          <Paragraph>{t("terms.sections.contact.content")}</Paragraph>
        </ContentBox>
      </Container>
    </PageContainer>
  );
};

export default TermsPage;
